import { render, staticRenderFns } from "./HeaderBannerCard.vue?vue&type=template&id=703fd448&scoped=true&"
import script from "./HeaderBannerCard.vue?vue&type=script&lang=js&"
export * from "./HeaderBannerCard.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBannerCard.vue?vue&type=style&index=0&id=703fd448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703fd448",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
